import { TableColumn } from '../../table/DataTable.types';

export const columns = (handleSelect?: any) =>
  [
    {
      accessor: 'name',
      name: 'page.code-book-item.col-name',
      hideFilter: true,
      searchInput: true,
      className: `w-[30%]`,
      cellRenderer(e) {
        return (
          <span
            onClick={() => handleSelect(e.id)}
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            {e.name}
          </span>
        );
      },
    },
    {
      accessor: 'code',
      name: 'page.code-book-item.col-code',
      hideFilter: true,
    },
    {
      accessor: 'vatCode',
      name: 'page.code-book-item.col-vat-code',
      hideFilter: true,
      cellRenderer(e) {
        if (e.vatCode && e.vat) return <span>{e.vatCode + ':' + e.vat}</span>;
      },
    },
    {
      accessor: 'price',
      hideFilter: true,
      name: 'page.code-book-item.col-price',
    },
    {
      accessor: 'currency',
      name: 'page.code-book-item.col-currency',
    },
    {
      accessor: 'unit',
      hideFilter: true,
      name: 'page.code-book-item.col-unit',
    },
  ] as TableColumn[];
